import script from "./ProduceOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./ProduceOrder.vue?vue&type=script&setup=true&lang=js"

import "./ProduceOrder.vue?vue&type=style&index=0&id=e8c3a762&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8c3a762"]])

export default __exports__